import React from "react";
import { weekDays } from "../../util/DateTools";


export const dateProvider = {
    getWeekDays,
}

function getWeekDays(){
    return weekDays.map( (value, index) => ({
            id: index +1 ,
            value: index +1 ,
            label: <label>{ value }</label>
        })
    )
}
